import _defineProperty from "@babel/runtime/helpers/defineProperty";
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { remCalc } from '@lux/helpers';
import { responsiveStyles } from '../../core/utils';
var SPACER = 8;
var spacing = function spacing(size) {
  return typeof size === 'string' ? size : remCalc(SPACER * size);
};
var getResponsivePadding = function getResponsivePadding(coreTheme, isResponsive) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'padding';
  var value = arguments.length > 3 ? arguments[3] : undefined;
  var position = arguments.length > 4 ? arguments[4] : undefined;
  var desktopValue = typeof value === 'number' && value > 0 ? isResponsive ? value + 1 : value : value;
  return Object.assign({}, responsiveStyles(_defineProperty({}, "".concat(type).concat(position), [spacing(value), spacing(value), spacing(desktopValue), spacing(desktopValue), spacing(desktopValue)]), coreTheme));
};
export var SpacingStyle = withTheme(styled.div.withConfig({
  displayName: "style__SpacingStyle",
  componentId: "sc-7nx7c-0"
})(["", ";"], function (p) {
  return css(["", ";", ";", ";", ";"], getResponsivePadding(p.coreTheme, p.responsive, p.type, p.top, 'Top'), getResponsivePadding(p.coreTheme, p.responsive, p.type, p.right, 'Right'), getResponsivePadding(p.coreTheme, p.responsive, p.type, p.bottom, 'Bottom'), getResponsivePadding(p.coreTheme, p.responsive, p.type, p.left, 'Left'));
}));